export default function WelcomeFooter() {
  const links = [
    { title: "Privacy Policy", href: "https://docs.labfigures.com/PrivacyPolicy.pdf" },
    { title: "Security Policy", href: "https://docs.labfigures.com/SecurityInfo.pdf" },
  ];

  return (
    <div className="full-width sg-row v-center h-center ">
      {links.map(({ title, href }) => (
        <div key={title} className="fair-padding ">
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="link"
          >
            {title}
          </a>
        </div>
      ))}

      <style jsx>{`
        .link {
          color: #666;
          font-weight: 600; /* Set baseline weight */
          display: inline-block;
          transition: transform 0.15s ease, color 0.15s ease;
        }

        .link:hover {
          color: #000;
          transform: scale(1.05); /* Gives emphasis without reflow */
        }
      `}</style>
    </div>
  );
}
